(function () {
    'use strict';

    function circleAutomaticFileUploader($rootScope, $log, sessionDataService, notifyService) {
        return {
            restrict: 'E',
            scope: {
                dropZoneElementClass: '@',
                allowedExtensions: '=',
                label: '@',
                fileType: '@',
                parent: '=',
                allowMultiple: '=?',
                maxFiles: '=?',
                uploadMessage: '=?'
            },
            transclude: true,
            templateUrl: 'common/directives/templates/circleAutomaticFileUploader.html',
            link: function (scope, element) {
                scope.uploads = [];
                scope.fileName = '';
                scope.percentComplete = 0;
                scope.totalBytes = 0;
                scope.uploadMessage = scope.uploadMessage || 'Drag & Drop or Click to Upload';

                scope.allowAllExtensions = scope.allowedExtensions.length === 1 && scope.allowedExtensions[0] === '*';
                var validation = scope.allowAllExtensions ? { } : { allowedExtensions: scope.allowedExtensions };
                var expandedValidation = {
                    sizeLimit: 2147483647
                };
                if (!scope.allowAllExtensions) {
                    expandedValidation.allowedExtensions = scope.allowedExtensions;
                }

                var uploader = new qq.azure.FineUploaderBasic({
                    request: { endpoint: "https://ecapwebstorage.blob.core.windows.net/uploads" },
                    signature: {
                        endpoint: "/sas?fileType=" + scope.fileType,
                        customHeaders: function (id) {
                            var matchingFile = scope.uploads[parseInt(id.toString().split('.')[0], 10)];
                            return {
                                "guid": matchingFile.BlobReference,
                                "fileName": matchingFile.FileName
                            }
                        }
                    },
                    uploadSuccess: {
                        endpoint: "/aus",
                        customHeaders: function (id) {
                            var matchingFile = scope.uploads[parseInt(id.toString().split('.')[0], 10)];
                            return {
                                "guid": matchingFile.BlobReference,
                                "fileType": scope.fileType
                            }
                        }
                    },
                    chunking: {
                        enabled: true,
                        concurrent: {
                            enabled: true
                        }
                    },
                    retry: {
                        enableAuto: false
                    },
                    debug: false,
                    button: $(element).find('.file-uploader-button')[0],
                    extraButtons: [
                        {
                            element: $(element).find('.fab-uploader-button')[0],
                            validation: validation
                        }
                    ],
                    multiple: scope.allowMultiple,
                    validation: expandedValidation,
                    autoUpload: true,
                    deleteFile: {
                        enabled: false
                    },
                    callbacks: {
                        onComplete: function (id, fileName, responseJson) {
                            var matchingUpload = scope.uploads[parseInt(id.toString().split('.')[0], 10)];
                            if (!matchingUpload) {
                                throw new Error('File to mark as uploaded - ' + fileName + ' was not found');
                            }

                            if (responseJson.success) {
                                sessionDataService.loadSession().then(function (sessionData) {
                                    matchingUpload.Complete = true;
                                    matchingUpload.UploadedByUserName = sessionData.UserName;
                                    matchingUpload.UploadedByEntityId = sessionData.EntityId;
                                    matchingUpload.UploadedByEntity = sessionData.Entity;

                                    if (!scope.uploads.find(function (upload) {
                                        return !upload.Complete;
                                    })) {
                                        scope.percentComplete = 0;
                                    }

                                    $rootScope.$broadcast('fileUploaded',
                                            { blobs: [matchingUpload], parent: scope.parent });
                                    scope.fileName = '';
                                });
                            }
                            else {
                                scope.percentComplete = 0;
                            }
                        },
                        onUpload: function (id, fileName) {
                        },
                        onSubmit: function (id, fileName) {
                            var guid = uuid.v4();
                            scope.uploads.push({
                                FileName: fileName,
                                BlobReference: guid,
                                DateUploaded: (new Date()).toISOString(),
                                UploadedByUserName: '',
                                UploadedByEntityId: null,
                                UploadedByEntity: null,
                                Complete: false,
                                Bytes: this.getSize(id)
                            });
                            scope.fileName = scope.uploads.filter(function (upload) {
                                return !upload.Complete;
                            }).map(function (upload) {
                                return upload.FileName;
                            }).join(', ');
                            scope.totalBytes = scope.uploads.map(function (upload) {
                                return upload.Bytes;
                            }).reduce(add, 0);
                            scope.$apply();
                        },
                        onProgress: function (id, fileName, uploadedBytes) {
                            scope.percentComplete = Math.floor((uploadedBytes / scope.totalBytes) * 100);
                            scope.$apply();
                        },
                        onError: function (id, name, reason, xhr) {
                            if (reason === 'No files to upload.') {
                                // do nothing
                            }
                            else if (reason.indexOf('Too many items') !== -1) {
                                notifyService.notify(
                                    'Too many items were selected. You are limited to ' + scope.maxFiles + ' uploads.', true);
                            }
                            else if (reason.indexOf('invalid extension') !== -1) {
                                notifyService.notify(
                                    'This file type is not allowed. The following file types are allowed: ' + 
                                    scope.allowedExtensions.join(', ') + ',', true);
                            }
                            else {
                                notifyService.notify("There was an error uploading " + name + ". Please try again.", true);
                                $log.warn(name + " - " + reason);
                            }
                        }
                    }
                });

                if (scope.maxFiles) {
                    uploader.setItemLimit(scope.maxFiles);
                }

                function add(a, b) {
                    return a + b;
                }

                var dragAndDropModule = new qq.DragAndDrop({
                    dropZoneElements: [$(element).find('.' + scope.dropZoneElementClass)[0]],
                    callbacks: {
                        processingDroppedFiles: function () {
                            //TODO: display some sort of a "processing" or spinner graphic
                        },
                        processingDroppedFilesComplete: function (files, dropTarget) {
                            //TODO: hide spinner/processing graphic
                            uploader.addFiles(files); //this submits the dropped files to Fine Uploader
                        }
                    }
                });

                scope.upload = function () {
                    uploader.uploadStoredFiles();
                }

                $rootScope.$on('fileRemoved',
                    function (event, args) {
                        if (args.parent.Path === scope.parent.Path) {
                            // TODO: anything here
                        }
                    });
            }
        };
    }

    circleAutomaticFileUploader.$inject = ['$rootScope', '$log', 'sessionDataService', 'notifyService'];

    angular.module('ecap.common').directive('circleAutomaticFileUploader', circleAutomaticFileUploader);
})();
